/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * This directive enables content block elements to be aligned.
 */
angular.module('bulbApp.contentEditorModule')

.directive('bulbAlignable', bulbAlignable);

function bulbAlignable() {
  return {
    require: ['^contentBlock', '^ngModel'],
    scope: {},
    link: function link(scope, elem, attr, ctrls) {
      var contentBlockCtrl = ctrls[0];
      var modelCtrl = ctrls[1];

      // TODO UNDO : how do we undo/redo a resize?

      // Rather than aligning the contentBlockElement that this directive is attached to, we instead align the
      // content block itself.
      var contentBlockElement = contentBlockCtrl.contentBlockElement;

      // Set up the initial currentAlignment based on the initial contentBlockElement class information:
      if (contentBlockElement) {
        contentBlockCtrl.alignment = 'center';
        if (contentBlockElement.hasClass('align-left')) {
          contentBlockCtrl.alignment = 'left';
        } else if (contentBlockElement.hasClass('align-right')) {
          contentBlockCtrl.alignment = 'right';
        }
      }

      scope.$watch(function() {
        return contentBlockCtrl.isFullWidth;
      }, function(isFullWidthBlock) {
        if (isFullWidthBlock) {
          angular.element(contentBlockElement).addClass('block-full-width');
        } else {
          angular.element(contentBlockElement).removeClass('block-full-width');
        }
      }, true);

      function alignContent(alignment) {
        contentBlockElement.removeClass('align-' + contentBlockCtrl.alignment);
        contentBlockCtrl.alignment = alignment;
        contentBlockElement.addClass('align-' + contentBlockCtrl.alignment);

        // We need to commit the view value, so that the change occurs immediately, rather than being delayed by
        // the debounce.  However, the debounce isn't initiated until the next digest cycle, so we need to
        // wait until after that, which is why evalAsync is used.
        scope.$evalAsync(function() {
          modelCtrl.$commitViewValue();
        });
      }

      scope.$on('command-align', function(event, alignment) {
        if (contentBlockCtrl.selected) {
          alignContent(alignment);
        }
      });
    }
  };
}
